import { render, staticRenderFns } from "./SelectRef.vue?vue&type=template&id=6dfebc0d&scoped=true&"
import script from "./SelectRef.vue?vue&type=script&lang=js&"
export * from "./SelectRef.vue?vue&type=script&lang=js&"
import style0 from "./SelectRef.vue?vue&type=style&index=0&id=6dfebc0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfebc0d",
  null
  
)

export default component.exports